import packageJSON from '../../package.json';

export const environment = {
  production: false,
  environmentName: 'DEV',
  activateStanford4p1: true,
  version: packageJSON.version,
  apiBaseUrl: 'https://foma-client-api-dev.sveaskog.se/api',
  allowedDomains: 'foma-client-api-dev.sveaskog.se',
  msalConfig: {
    auth: {
      clientId: "3e9006bd-f99c-44c3-af35-f3ecd530552d",
      authority: "https://login.microsoftonline.com/9defa683-0dca-4a4d-86f1-4e4d7759c8c3",
      validateAuthority: true,
      redirectUri: "https://foma-dev.sveaskog.se/",
      postLogoutRedirectUri: "/",
      navigateToLoginRequestUrl: true
    },
    resources: {
      resourceUri: "https://foma-client-api-dev.sveaskog.se",
      resourceScope: "api://3e9006bd-f99c-44c3-af35-f3ecd530552d/user.signin"
    },
    scopes: {
      loginRequest: [
        "openid",
        "profile"
      ]
    }
  },
  appInsights: {
    instrumentationKey: '89c19dca-a890-4b14-b49a-31ab90a3ce70'
  }
};
